export const university = {
  TiU: "TiU",
  "TU/e": "TU/e",
};
